<template>
  <div class="index">
    <div class="tieZi"  >
      <mt-navbar  :fixed="true" v-model="selected" style="border-bottom:1px solid lightgray;">
        <mt-tab-item  id="1" style="border-right:1px solid lightgray;" @click.native="newest">最新</mt-tab-item>
        <mt-tab-item  id="2" style="border-right:1px solid lightgray;" @click.native="hottest">最热</mt-tab-item>
        <mt-tab-item  id="3" style="border-right:1px solid lightgray;" @click.native="information">动态</mt-tab-item>
        <mt-tab-item @click.native="onClick()">更多ˇ</mt-tab-item>
      </mt-navbar>
      <!-- <mt-tab-container v-model="selected">
       </mt-tab-container>-->
      <!--动态类型选择-->
      <div>
        <van-popup v-model="showInfoType" position="bottom">
          <van-picker
            show-toolbar
            :columns="infoType"
            @cancel="cancelInfoType"
            @confirm="confirmInfoType"
          />
        </van-popup>
      </div>

    </div>
    <wv-tabbar :fixed="true">
      <wv-tabbar-item to="/" is-on>
        <span slot="icon" style="display: inline-block; position: relative;">
          <img class="weui-tabbar__icon" src="../assets/eye.png" slot="icon">
        </span>
        发现
      </wv-tabbar-item>
      <div v-if="roleType==='2'">
        <wv-tabbar-item to="/tieZi" >
          <img class="weui-tabbar__icon" src="../assets/edit.png" slot="icon" > 发帖
        </wv-tabbar-item>
      </div>

      <wv-tabbar-item >
        <img class="weui-tabbar__icon" src="../assets/userbar.png" slot="icon"  @click="loginCheck()" > 我的
      </wv-tabbar-item>
    </wv-tabbar>
    <!--显示最新-->
    <div v-if="selectFlag==='1'">
      <van-list
        v-model="loading"
        :finished="finished"
        loading-text="加载中..."
        finished-text="没有更多了"
        @load="newestOnLoad"
      >
        <div class="content"  v-for="(item, index) in myObj" :key="index">
          <div class="content-item" @click="openDetail(item.id)">
            <div class="top" style="padding-top: 10px">
              <div class="headPortrait" ><img src="../assets/user.png" alt=""></div>
              <div class="baseInfo" >
                <div class="nameAndTime">
                  <span class="name">{{item.userName | hideMiddle}}</span>
                  <span class="time">{{item.createTime| formatDate}}</span>
                </div>
                <div class="typeAndTitle">
                  <span  v-if="item.tieziType===1" class="type" style="background: #EC971F">投诉</span>
                  <span  v-if="item.tieziType===2 " class="type" style="background: #E9DC51">建议</span>
                  <span  v-if="item.tieziType===3 " class="type"style="background: #25A597">咨询</span>
                  <span  v-if="item.tieziType===4 " class="type">表扬</span>
                  <span class="title">
                  {{item.title}}
                </span>
                </div>
              </div>
            </div>
            <div class="center" >
              {{item.content}}
            </div>

            <div class="imgShow"  v-if=" item.image != null">
              <div class="imgShow-item"  v-for="(url,idx) in item.image.split(';')" :key="idx">
                <img :src="getImgUrl(url) ">
              </div>
            </div>


            <div class="bottom1">
              <div class="classify">

                {{item.serviceItemName}}/ {{item.serviceItemIdName}}
              </div>
              <div class="option">
                <div class="browse">
                  浏览:<span  v-if="item.browseCount===null" class="browseCount">0</span>
                  <span  v-else class="browseCount">{{item.browseCount}}</span>
                  &nbsp;&nbsp;
                  <span  class="iconfont aliaixin" style="position:relative;top:1px;"></span>
                  <span v-if="item.greatCount===null" class="greatCount">0</span>
                  <span  v-else class="greatCount">{{item.greatCount}}</span>
                  &nbsp;&nbsp;
                  <span class="iconfont alipinglun1" style="position:relative;top:1px;"></span>
                  <span v-if="item.replyCount===null" class="replyCount">0</span>
                  <span  v-else class="replyCount">{{item.replyCount}}</span>
                  &nbsp;&nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>

      </van-list>
    </div>
    <!--显示最热-->
    <div v-if="selectFlag==='2'">
      <van-list
        v-model="loading"
        :finished="finished"
        loading-text="加载中..."
        finished-text="没有更多了"
        @load="hottestOnLoad"
      >
        <div class="content"  v-for="(item, index) in myObj" :key="index">
          <div class="content-item" @click="openDetail(item.id)">
            <div class="top" style="padding-top: 10px">
              <div class="headPortrait" ><img src="../assets/user.png" alt=""></div>
              <div class="baseInfo" >
                <div class="nameAndTime">
                  <span class="name">{{item.userName|hideMiddle}}</span>
                  <span class="time">{{item.createTime| formatDate}}</span>
                </div>
                <div class="typeAndTitle">
                  <span  v-if="item.tieziType===1" class="type" style="background: #EC971F">投诉</span>
                  <span  v-if="item.tieziType===2 " class="type" style="background: #E9DC51">建议</span>
                  <span  v-if="item.tieziType===3 " class="type"style="background: #25A597">咨询</span>
                  <span  v-if="item.tieziType===4 " class="type">表扬</span>
                  <span class="title">
                  {{item.title}}
                </span>
                </div>
              </div>
            </div>
            <div class="center">
              {{item.content}}
            </div>
            <div class="imgShow"  v-if=" item.image != null">
              <div class="imgShow-item"  v-for="(url,idx) in item.image.split(';')" :key="idx">
                <img :src="getImgUrl(url) ">
              </div>
            </div>

            <div class="bottom1">
              <div class="classify">

                {{item.serviceItemName}}/ {{item.serviceItemIdName}}
              </div>
              <div class="option">
                <div class="browse">
                  浏览:<span  v-if="item.browseCount===null" class="browseCount">0</span>
                  <span  v-else class="browseCount">{{item.browseCount}}</span>
                  &nbsp;&nbsp;
                  <span  class="iconfont aliaixin" style="position:relative;top:1px;"></span>
                  <span v-if="item.greatCount===null" class="greatCount">0</span>
                  <span  v-else class="greatCount">{{item.greatCount}}</span>
                  &nbsp;&nbsp;
                  <span class="iconfont alipinglun1" style="position:relative;top:1px;"></span>
                  <span v-if="item.replyCount===null" class="replyCount">0</span>
                  <span  v-else class="replyCount">{{item.replyCount}}</span>
                  &nbsp;&nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>

      </van-list>
    </div>
    <!--显示动态-->
    <div v-if="selectFlag==='3'">
      <van-list
        v-model="loading"
        :finished="finished"
        loading-text="加载中..."
        finished-text="没有更多了"
        @load="InfoOnLoad"
      >

        <div class="content"  v-for="(item, index) in myObj" :key="index">
          <div class="content-item" @click="openInfoDetail(item.id)">
            <div class="top" style="padding-top: 10px">
              <div class="baseInfo" >
                <div class="titleInfo" >
                  <span class="titleInfo" style="font-weight: bold;font-size: 16px">{{item.title}}</span>
                </div>
                <div class="categoryNameAndTime">
                  <span class="categoryName">[{{item.categoryName}}]</span>
                  &nbsp;&nbsp;
                  <span class="time">{{item.createTime| formatDate}}</span>
                </div>
              </div>
            </div>
            <div class="infoContent"  v-html="item.content" >
              {{item.content}}
            </div>
            <div class="imgShow"  v-if=" item.image != null && item.image.length >0  ">
              <div class="imgShow-item"  v-for="(url,idx) in item.image.split(',')" :key="idx"  v-if="idx < 5">
                <img :src="getImgUrl(url)"   :id="idx" >
                <!-- <img :src="getImgUrl(url)"  :id="idx" >-->
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>

</template>

<script>
  import contentText from './contentText'
  import moveView from './moveView'
  import { Toast,MessageBox} from 'mint-ui';
  import { getNewestTieZi,getPopularTieZi,getBrowseCount,getInformation,getInfoBrowseCount,getInfoType,getListByInfoTypeName,getUserInfoByValidateurlPC,getUserInfoByValidateurl,logonSSO,adminLoginSSO, OK,HOST,menHuUrl,casHost} from '../api/data.js'
  import moment from 'moment'
  import Vue from 'vue'
  import { List } from 'vant';
  import {getUserInfo} from "./index";
  import wxApi from '../assets/js/wxshare'
  Vue.use(List);
  export default {
    data() {
      return {
        inputShowed: false,
        inputVal: "",
        popupVisible5:"true",
        selected:this.$store.state.selected,
        tieZiType:0,
        roleType:this.$store.state.roleType,
        isAdminType:this.$store.state.isAdminType,
        myTieziObj:{},
        newestList: [],
        hottestList: [],
        informationList: [],
        infoTypeName:this.$store.state.infoTypeName,
        infoType:[],
        showInfoType:false,
        loading: false,
        finished: false,
        selectFlag:"1",//1:最新页面 2 最热 3 动态
        isNewest:true,
        title:'后勤服务监督平台',//分享标题
        imgLogo: require('../assets/logo.png'),// 分享图标
        desc: '可点击', //分享描述
        token:""
      }
    },
    filters: {
      formatDate: function (value) {
        return moment(value).format('YYYY-MM-DD HH:mm')
      },
      hideMiddle(val) {
        return `${val.substring(0,1)}**`
      }
    },
    computed: {
      myObj: {
        get: function(){
          //console.log("this.selectFlag:"+this.selectFlag)
          switch (this.selectFlag) {
            case "1":
              //console.log("this.selectFlag1:"+this.selectFlag)
              return this.newestList;
              break;
            case "2":
              // console.log("this.selectFlag2:"+this.selectFlag)
              return this.hottestList;
              break;
            case "3":
              // console.log("this.selectFlag3:"+this.selectFlag)
              return this.informationList;
              break;
          }
        }
      }
    },

    beforeCreate: function () {
      let ticket = decodeURIComponent((new RegExp('[?|&]' +  'ticket' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
      this.isAdminType = this.$store.state.isAdminType;

      this.roleType= this.$store.state.roleType;

      const userType = localStorage.getItem("userType");

    if(ticket!=null){
        this.roleType= this.$store.state.roleType;
        //console.log(" this.roleType:"+ this.roleType);

        if(userType==="admin"){
          if(this.roleType==='1'){
            window.location.href = '/#/adminCasLogin'
          }
        }else {
          if(this.roleType==='1'){
            window.location.href = '/#/stuCasLogin'
          }
        }

      }

    },
    created: function () {

      if(window.location.pathname=="/stuCasLogin"){
        this.$router.replace('/stuCasLogin');
      }else {
        if (this._isMobile()) {
          this.loginCheck()
          //alert('手机端');
          this.$router.replace('/');
        }else {
          //alert('pc端');
          this.$router.replace('/pc');
        }
      }
    },
    //页面加载
    mounted() {

      //console.log('页面selected:'+this.selected)
      switch (this.selected) {
        case "1": //最新
          this.newest();
          break;
        case "2": //最热
          this.hottest()
          break;
        case "3"://动态
          this.getListByInfoTypeName(this.infoTypeName)
          break;
        default:
          this.newest();
          break;
      }

      this.getInfoType();
      this.showInfoType = false;


    },
    methods: {
      // 判断移动端还是pc端
      _isMobile(){
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
      },
      //登录检测 如果已经登录则跳转到我的帖子界面否则跳转到登录界面
      loginCheck(){
        let isLogin =localStorage.getItem("Flag");
        if(isLogin=="isLogin"){ //跳转到我的帖子界面
          let operator = localStorage.getItem("operator");
          this.roleType= this.$store.state.roleType;
          if(this.roleType=='3'){ //跳转到管理员界面
            if(operator!=null){

              this.$store.dispatch('setRoleType',"3");//记录登录的角色
              this.$router.push({path:'/adminIndex'})
            }else{
              this.$store.dispatch('setRoleType',"2");//记录登录的角色
              this.$router.push({path:'/myTZ'})
            }
          }else{ //跳转到教职工我的帖子界面
            this.$store.dispatch('setRoleType',"2");//记录登录的角色
            this.$router.push({path:'/myTZ'})
          }
        }else{//跳转到登录界面
          this.$store.dispatch('setRoleType',"1");//记录登录的角色
          this.$router.push({path:'/login'})
        }
      },
      getUrlKey: function (name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
      },
      //获取动态类名称
      getInfoType(){
        getInfoType().then((res) => {
          if(res.status === OK) {
            let i = 1;
            this.infoType[0] = "全部"
            for (i =0;i<res.data.data.length;i++) {
              /*  console.log("动态类型名称")
                console.log(res.data)*/
              this.infoType[i+1] =res.data.data[i].name;
            }
          }else{
            Toast('获取动态类型失败')
          }
        })
          .catch((error) => {
            console.log(error)
          });
      },

      //最新加载
      newestOnLoad() {
        // 异步更新数据
        setTimeout(() => {
          if(this.myTieziObj.data!=null && this.myTieziObj.data.length<=10){
            this.newestList = this.myTieziObj.data;
            this.finished = true;
            // 加载状态结束
            this.loading = false;
          }else{
            setTimeout(() => {
              for (let i = 0; i < 10; i++) {

                if(this.newestList.length<this.myTieziObj.data.length){
                  this.newestList.push(this.myTieziObj.data[this.newestList.length ]);
                }
              }
              // 加载状态结束
              this.loading = false;
              // 数据全部加载完成
              if (this.newestList.length >= this.myTieziObj.data.length) {
                this.finished = true;
              }
            }, 500);
          }

        }, 1500);
      },
      //最热加载
      hottestOnLoad(){
        // 异步更新数据
        setTimeout(() => {
          // console.log("最热myTieziObj.data")
          // console.log(this.myTieziObj.data)
          if(this.myTieziObj.data.length<=10){
            this.hottestList = this.myTieziObj.data;
            this.finished = true;
            // 加载状态结束
            this.loading = false;
          }else{
            setTimeout(() => {
              for (let i = 0; i < 10; i++) {
                if(this.hottestList.length<this.myTieziObj.data.length){
                  this.hottestList.push(this.myTieziObj.data[this.hottestList.length ]);
                }
              }
              // 加载状态结束
              this.loading = false;
              // 数据全部加载完成
              if (this.hottestList.length >= this.myTieziObj.data.length) {
                this.finished = true;
              }
            }, 500);
          }
        }, 1000);
      },
      //动态加载
      InfoOnLoad(){
        // 异步更新数据
        setTimeout(() => {
          // console.log("动态myTieziObj.data")
          // console.log(this.myTieziObj.data)
          if(this.myTieziObj.data.length<=10){
            this.informationList = this.myTieziObj.data;
            this.finished = true;
            // 加载状态结束
            this.loading = false;
          }else{
            setTimeout(() => {
              for (let i = 0; i < 10; i++) {
                if(this.informationList.length<this.myTieziObj.data.length){
                  this.informationList.push(this.myTieziObj.data[this.informationList.length ]);
                }
              }
              // 加载状态结束
              this.loading = false;
              // 数据全部加载完成
              if (this.informationList.length >= this.myTieziObj.data.length) {
                this.finished = true;
              }
            }, 500);
          }
        }, 1000);

      },
      getImgUrl(imageUrl){
        return HOST+imageUrl;
      },
      onClick () {
        this.$router.push({name: "more"});

      },
      newest(){
        this.finished = false;
        this.isNewest = true;
        this.selectFlag ='1';
        this.$store.dispatch('setSelected',"1")
        this.showInfoType = false;
        getNewestTieZi().then(res=>{
          if(res.status === OK) {
            if(res.data.success==true){
              this.myTieziObj=[];
              this.myTieziObj=res.data ; // 在这里用临时变量接受服务端返回值
              this.newestOnLoad();
              this.imgLogo = HOST+  this.imgLogo
              wxApi.wxShowMenu(this.imgLogo,this.desc,this.title)

            }else{
              Toast('获取帖子记录失败')
            }
          }
        }).catch(error=>{
          console.log("错误"+error);
        })
      },
      hottest(){
        this.finished = false;
        this.isNewest = false;
        this.selectFlag ='2';
        this.$store.dispatch('setSelected',"2")
        this.showInfoType = false;
        getPopularTieZi().then(res=>{
          if(res.status === OK) {
            if(res.data.success==true){
              this.myTieziObj=[];
              this.myTieziObj=res.data ; // 在这里用临时变量接受服务端返回值
              //console.log(this.myTieziObj);
              this.hottestOnLoad();
              this.imgLogo = HOST+  this.imgLogo
              wxApi.wxShowMenu(this.imgLogo,this.desc,this.title)

            }else{
              Toast('获取帖子记录失败')
            }
          }
        }).catch(error=>{
          console.log("错误"+error);
        })
      },
      //动态
      getListByInfoTypeName(name){
        this.finished = false;
        this.selectFlag ='3';
        this.$store.dispatch('setSelected',"3")
        this.$store.dispatch('setInfoTypeName',name)
        getListByInfoTypeName(name).then(res=>{
          if(res.status === OK) {
            if(res.data.success==true){
              /* this.informationList=[];
               this.informationList=res.data.data ; // 在这里用临时变量接受服务端返回值*/
              this.myTieziObj=[];
              this.myTieziObj=res.data ; // 在这里用临时变量接受服务端返回值
              this.InfoOnLoad();
            }else{
              Toast('获取动态失败')
            }
          }
        }).catch(error=>{
          console.log("错误"+error);
        })
      },
      confirmInfoType(value, index) {
        //this.value = value;
        this.showInfoType = false;
        //console.log(`当前值：${value}, 当前索引：${index}`);
        this.getListByInfoTypeName(value);
      },
      cancelInfoType(value, index){
        this.showInfoType = false;
      },


      information(){
        this.finished = false;
        this.selectFlag ='3';
        this.$store.dispatch('setSelected',"3")
        this.showInfoType = true;
        getInformation().then(res=>{
          if(res.status === OK) {
            if(res.data.success==true){
              /* this.informationList=[];
               this.informationList=res.data.data ; // 在这里用临时变量接受服务端返回值*/
              this.myTieziObj=[];
              this.myTieziObj=res.data ; // 在这里用临时变量接受服务端返回值

              this.InfoOnLoad();
            }else{
              Toast('获取动态失败')
            }
          }
        }).catch(error=>{
          console.log("错误"+error);
        })
      },
      openDetail(value){
        getBrowseCount(value).then(res=>{
          if(res.status === OK) {
            if(res.data.success==true){

              // Toast('浏览成功')
            }else{
              //Toast('浏览失败')
            }
          }
        }).catch(error=>{
          console.log("错误"+error);
        })

        this.$router.push({path:'/detail',
          query: {
            tieZiId: value
          }})
      },
      openInfoDetail(value){

        getInfoBrowseCount(value).then(res=>{
          if(res.status === OK) {
            if(res.data.success==true){

              // Toast('浏览成功')
            }else{
              //Toast('浏览失败')
            }
          }

        }).catch(error=>{
          console.log("错误"+error);
        })

        this.$router.push({path:'/infoDetail',
          query: {
            infoId: value
          }})
      }
    },
    components:{
      contentText,
      moveView
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/baseScss.scss";
  .index{
    margin-top:25px;
    margin-bottom:50px;
    .mint-navbar{
      a{
        .mint-tab-item-label{
        }
      }

      .mint-tab-item{
        padding:10px 0;
        font-size: 13px;
      }
      .mint-tab-item-label{
        font-size: 13px;
        border-right: solid 1px $cl9;
      }
    }
    .mint-tab-item.is-selected{
      border:none;
    }
    .is-selected{
      margin-bottom: 0px !important;
    }
  }
  .content{
    font-size:0.8rem;
    color:gray;
    .content-item{
      border-bottom:1px solid lightgray;
      padding:0.8rem 0.5rem;
      .top{
        display:flex;
        .headPortrait{
          margin-right: 0.3rem;
          img{
            width: 2rem;
            height:2rem;
          }
        }
        .baseInfo{
          padding:1px 0;
          .nameAndTime{
            text-align:left;
            overflow: hidden;
            .name{
              margin-right:2rem;
            }
            .time{

            }
          }
          .typeAndTitle{
            overflow:hidden;
            .type{
              padding:0.1rem 0.5rem;
              color:white;
              background:#4caf50;
              border-radius: 10%;
              margin-right:1rem;
              font-weight:lighter;
            }
            .infoTitle{
              width:100%;
              height:50px;
              line-height:25px;
              overflow:hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            .title{
              color:black;
            }
          }
        }
      }
      .center{
        padding:0.5rem;
        text-align:left;
        margin-top: 20px;
        word-break:break-all;
        .imgShow{
          display:flex;

          align-items: center;
          justify-content: space-around;


        }
      }
      div{ word-wrap: break-word; word-break: normal;}
      .titleInfo{
        width:100%;
        height:25px;
        line-height:25px;
        overflow:hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .infoContent{
        width:100%;
        height:20px;
        line-height:20px;
        overflow:hidden;
        text-overflow: ellipsis;
        /* display: -webkit-box;*/
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .imgShow-item{

        width:3.5rem;
        height:3.5rem;
        padding:0.2rem;
        margin-left: 5px;
        display: inline-block;
        img{
          width:100%;
          height:100%;
        }
      }

      .bottom1{
        overflow:hidden;
        .classify{
          float:left;
        }
        .option{
          float:right;
          overflow:hidden;
          .browse{
            float:left;
          }
          .infobrowse{
            float:left;
            padding-top: 6px;
            margin-right: 12px;
          }

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue